import type { AgreementPreviewRow, AgreementRowInput } from "./types";

// Brand green constant — used where an inline style is needed (matches the `green` Tailwind token).
export const GREEN = "#28A745";

// Loan types selectable in the agreement editable preview's "Tur" column
// (keys map to import.agreements.loanType.*).
export const AGREEMENT_TYPES = [
  "car",
  "technology",
  "building",
  "loan",
  "other",
  "service",
] as const;

// Maps a validated preview row back to the editable raw-input shape used by the editable table.
// Values are strings exactly as the editable cells expect; the backend re-parses them on commit.
export function previewRowToInput(r: AgreementPreviewRow): AgreementRowInput {
  return {
    identifier: r.identifier ?? "",
    type: r.type ?? "",
    name: r.name ?? "",
    cost_price: r.cost_price ?? "",
    selling_price: r.selling_price ?? "",
    down_payment: r.down_payment ?? "",
    monthly_payment: r.monthly_payment ?? "",
    payment_count: r.payment_count != null ? String(r.payment_count) : "",
    first_payment_date: r.first_payment_date ?? "",
    payment_day: r.payment_day != null ? String(r.payment_day) : "",
    paid_amount: r.paid_amount ?? "",
    note: r.note ?? "",
    notification_before: String(r.notification_before ?? ""),
  };
}
